import React from "react";
import Select from "react-select";
import {useGlobal} from "reactn";

export const Dropdown = ({name, register, items, onChange}) => {
    const [theme] = useGlobal("theme");
    const colourStyles = {
        dropdownIndicator: (styles) => {
            return {
                ...styles,
                color: "#000",
                fontSize: "1.125rem",
                marginRight: "1rem",
            };
        },
        placeholder: (styles) => {
            return {
                ...styles,
                color: "#000",
                fontFamily: theme.font,
            };
        },
        valueContainer: (styles) => {
            return {...styles, padding: "0 1rem !important"};
        },
        singleValue: (styles) => {
            return {
                ...styles,
                color: "#000",
                fontFamily: theme.font,
            };
        },
        control: (styles, {isFocused}) => ({
            ...styles,
            width: "auto",
            borderRadius: 50,
            padding: "7px 10px",
            border: "1px solid #515151",
            borderColor: "#949494",
            cursor: "text",
            boxShadow: "none",
            outline: isFocused ? "#515151 solid 2px " : "0",
            outlineOffset: "5px",
            "&:hover": {
                borderColor: theme.colors.primary,
            },
        }),
        menu: (styles) => {
            return {
                ...styles,
                borderRadius: 0,
                overflow: "hidden",
                padding: 0,
            };
        },
        menuList: (styles) => {
            return {...styles, padding: 0};
        },
        option: (styles, {isDisabled, isSelected, isFocused}) => {
            return {
                ...styles,
                color: isSelected ? "white" : "black",
                padding: 15,
                background: isSelected ? theme.colors.gradient : "white",
                border: isFocused ? "1px solid #515151" : "none",
                boxShadow: isFocused ? "0px 0px -10px #515151" : "none",                
                backgroundColor: isSelected ? theme.colors.primary : "#fff",
                cursor: isDisabled ? "not-allowed" : "pointer",
                fontFamily: theme.font,
                zIndex: 3,
                ":hover": {
                    backgroundColor: theme.colors.primary,
                    color: "#fff",
                },
                ":active": {
                    ...styles[":active"],
                    backgroundColor: theme.colors.primary,
                },
            };
        },
    };
    return (
        <Select
            ref={register}
            name={name}
            kay={name}
            id={name}
            isSearchable={false}
            aria-label={""}
            placeholder={""}
            options={items}
            styles={colourStyles}
            onChange={onChange}
            components={{
                IndicatorSeparator: () => null,
            }}
        />
    );
};
